import React, { useRef } from "react";
import { useParams } from "react-router-dom";
// import LoadingBar from "react-top-loading-bar";

import DocSigningPreviewDoc from "./DocSigningPreviewDoc.jsx";
import AskPassword from "../../document_sinner/AskPassword.jsx";
// import DashboardHeader from '../common/DashboardHeader';
import useGetCombineDocMetadataForDocumentSigningFlow from "../../../customHook/useGetCombinedMetadataForDocumentSigningFlow";
// import PageNotFound from './PageNotFound';
import SpinnerLoader from "../../document_sinner/SpinnerLoader.jsx";

function DocPreviewCombinedSigners() {
  const ref = useRef();
  const { id } = useParams();
  const {
    docInfo,
    notfound,
    showPasswordPopup,
    onPassSubmit,
    passError,
    setDecPassword,
    isProgress,
  } = useGetCombineDocMetadataForDocumentSigningFlow({ id });
  console.log("docInfo", docInfo);
  return (
    <>
      {/* <DashboardHeader /> */}
      <SpinnerLoader isOpen={isProgress} />

      <AskPassword
        decryptionPopup={showPasswordPopup}
        onPassSubmit={onPassSubmit}
        passError={passError}
        setDecPassword={setDecPassword}
      />
      {/* {notfound && <PageNotFound />} */}
      {docInfo && (
        <div style={{ marginTop: "60px" }}>
          <DocSigningPreviewDoc metadata={docInfo} title={docInfo.blob.title} />
        </div>
      )}
    </>
  );
}

export default DocPreviewCombinedSigners;
